<template>
  <div>
    <h1>Report abuse</h1>
    <p>
      Unmatched Maker is intended as a friendly space for people to create and
      share custom decks for Unmatched. If you find material on the site that
      you believe is offensive or inappropriate, please
      <router-link :to="{ name: 'Contact' }">let me know</router-link>.
    </p>
  </div>
</template>

<script>
export default {
  name: "ReportAbuse",
  metaInfo: {
    title: "Report abuse"
  }
};
</script>
